<template>
  <v-card outlined class="card-center pb-2">
    <validation-observer v-slot="{ invalid }">
      <v-card class="px-4 py-4" outlined>
        <v-card-title class="py-0">
          {{ $t('ELE0028') }}
        </v-card-title>
        <v-card-text>
          <v-row dense class="mb-1">
            <v-col cols="4">
              <InspecionCompanyInput v-model="searchCondition.inspCompanyCd" />
            </v-col>
            <v-col cols="4">
              <TextFieldInput v-model="searchCondition.inspIndexNo" :label="$t('ELE0137')" />
            </v-col>
            <v-col>
              <TextFieldInputWithDatePicker v-model="searchCondition.inspDateFrom" :label="$t('ELE0138')" />
            </v-col>
            <span class="d-flex flex-row space-between mx-4 mt-3">
              {{ $t('ELE0141') }}
            </span>
            <v-col>
              <TextFieldInputWithDatePicker v-model="searchCondition.inspDateTo" :label="$t('ELE0138')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <TextFieldInput v-model="searchCondition.lotNo" :label="$t('ELE0049')" />
            </v-col>
            <v-col cols="2">
              <TextFieldInput v-model="searchCondition.partCd" :label="$t('ELE0031')" />
            </v-col>
            <v-col cols="2">
              <TextFieldInput v-model="searchCondition.model" :label="$t('ELE0224')" />
            </v-col>
            <v-col cols="3">
              <SelectMultipleInput
                v-model="searchCondition.inspStatus"
                :items="inspStatusItems"
                item-text="inspStatusText"
                item-value="inspStatusCd"
                :label="$t('ELE0139')"
              />
            </v-col>
            <v-col>
              <Checkbox v-model="searchCondition.showAutoCompleted" :label="$t('ELE0344')" />
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="3">
              <InspCat1MultipleInput v-model="searchCondition.inspCat1" validOnly />
            </v-col>
            <v-col cols="3">
              <InspCat2MultipleInput v-model="searchCondition.inspCat2" validOnly />
            </v-col>
            <v-col cols="2">
              <Checkbox v-model="searchCondition.srcInspNeeded" :label="$t('ELE0494')" />
            </v-col>
            <v-col class="d-flex justify-end mt-1">
              <BtnSearch @click="onClickSearch" :disabled="invalid" />
            </v-col>
          </v-row>
          <v-row>
            <v-card outlined>
              <v-card-title>
                {{ $t('ELE0023') }}
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:item.action="{ item }">
                  <IconInquiry @click="onClickInspSub(item)" />
                </template>
                <template v-slot:[`item.inspStatusCd`]="{ item }">
                  {{ getEnumlang('InspIndex.InspStatusCd.', item.inspStatusCd) }}
                </template>
                <template v-slot:[`item.isSrcInsp`]="{ item }">
                  {{ getEnumlang('isSrcInsp.', item.isSrcInsp.toString()) }}
                </template>
                <template v-slot:[`item.inspResultCd`]="{ item }">
                  <td
                    class="v-data-table__divider"
                    :style="{ 'background-color': getColorInspResult(item.inspResultCd) }"
                  >
                    {{ getInspResultName('InspResultCd.', item.inspResultCd, item.isOutCl) }}
                  </td>
                </template>
                <template v-slot:[`item.srcInspResultCd`]="{ item }">
                  <td
                    class="v-data-table__divider"
                    :style="{ 'background-color': getColorInspResult(item.srcInspResultCd) }"
                  >
                    {{ getEnumlang('InspResultCd.', item.srcInspResultCd) }}
                  </td>
                </template>
                <template v-slot:[`item.inspTimingCd`]="{ item }">
                  {{ getEnumlang('InspTiming.', item.inspTimingCd) }}
                </template>
                <template v-slot:item.inspIndexNo="{ item }">
                  <div class="d-flex align-center">
                    <BtnLink :label="item.inspIndexNo" @click="onClickEdit(item.inspIndexNo)" />
                    <v-icon color="primary" @click="onClickCopy(item.inspIndexNo)">mdi-content-copy</v-icon>
                  </div>
                </template>
                <template v-slot:item.inspStartDatetime="{ item }">
                  {{ toLocalTime(item.inspStartDatetime) }}
                </template>
                <template v-slot:item.inspEndDatetime="{ item }">
                  {{ toLocalTime(item.inspEndDatetime) }}
                </template>
                <template v-slot:item.lotNo="{ item }">
                  <BtnLink
                    v-if="enumOqcIqcCd.IQC == item.inspTimingCd"
                    :label="item.lotNo"
                    @click="onClickLotNo(item)"
                  />
                  <div v-else>
                    {{ item.lotNo }}
                  </div>
                </template>
                <template v-slot:item.mmmmApplNo="{ item }">
                  <div class="d-flex align-center">
                    {{ item.mmmmApplNo }}
                    <IconInquiry v-if="can4MClicked(item)" @click="onClickMmmmSub(item)" />
                  </div>
                </template>
                <template v-slot:[`item.dispositionCd`]="{ item }">
                  {{ getEnumlang('MmmmDispositionCd.', item.dispositionCd) }}
                </template>
              </v-data-table>
            </v-card>
          </v-row>
        </v-card-text>
      </v-card>
    </validation-observer>
    <InspIndexDialog
      v-if="indexDialog"
      :dialog.sync="indexDialog"
      :mode="mode"
      :inspIndexNo="selectedIndexNo"
      @close="onClickSearch"
    />
    <SearchInspLotSubDialog
      v-if="subDialog"
      :dialog.sync="subDialog"
      :inspIndexNo="selectedSubItems.inspIndexNo"
      :manufacturerCompanyName="selectedSubItems.manufacturerName"
      :inspCompanyName="selectedSubItems.inspCompanyName"
      :lotDate="selectedSubItems.lotDate"
      :lotNo="selectedSubItems.lotNo"
      :partCd="selectedSubItems.partCd"
      :inspStatusCd="selectedSubItems.inspStatusCd"
      @close="onClickSearch"
    />
    <SearchMmmmSubDialog
      v-if="mmmmSubDialog"
      :dialog.sync="mmmmSubDialog"
      :inspCompanyCd="selectedMmmmItems.inspCompanyCd"
      :inspCompanyName="selectedMmmmItems.inspCompanyName"
      :lotNo="selectedMmmmItems.lotNo"
      :partCd="selectedMmmmItems.partCd"
      :inspIndexNo="selectedMmmmItems.inspIndexNo"
      @close="onClickSearch"
    />
    <v-dialog v-if="mmmmDialog" v-model="mmmmDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0491') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="mmmmDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <MmmmRequestForm :propsMmmmNo="selected4MLink" isModal @close="mmmmDialog = false" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment'
import { ValidationObserver } from 'vee-validate'
import { ModalMode, InspStatusCd, OqcIqcCd, InspResultCd, InspectionIndex4M } from '@/enum'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import Btn from '@/components/atoms/base/button/Btn.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import IconInquiry from '@/components/atoms/icon/IconInquiry'

import InspecionCompanyInput from '@/components/atoms/select/InspecionCompanyInput'
import SearchInspLotSubDialog from '@/components/organisms/terminal/dialog/SearchInspLotSubDialog'
import InspIndexDialog from '@/components/organisms/terminal/dialog/InspIndexDialog'
import InspCat1MultipleInput from '@/components/atoms/select/InspCat1MultipleInput'
import InspCat2MultipleInput from '@/components/atoms/select/InspCat2MultipleInput'
import MmmmRequestForm from '@/components/organisms/terminal/form/MmmmRequestForm.vue'
import SearchMmmmSubDialog from '@/components/organisms/terminal/dialog/SearchMmmmSubDialog'

export default {
  name: 'SearchInspIndexForm',

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils],

  components: {
    ValidationObserver,
    Btn,
    BtnSearch,
    BtnLink,
    Checkbox,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    SelectMultipleInput,
    IconInquiry,
    InspecionCompanyInput,
    SearchInspLotSubDialog,
    InspIndexDialog,
    InspCat1MultipleInput,
    InspCat2MultipleInput,
    MmmmRequestForm,
    SearchMmmmSubDialog,
  },

  data() {
    return {
      subDialog: false,
      mmmmSubDialog: false,
      indexDialog: false,
      mode: '',
      selectedIndexNo: '',
      selectedSubItems: null,
      inspStatusItems: [],
      items: [],
      headers: [
        { text: this.$t('ELE0307'), value: 'action', divider: true, sortable: false },
        { text: this.$t('ELE0139'), value: 'inspStatusCd', divider: true },
        { text: this.$t('ELE0502'), value: 'isSrcInsp', divider: true },
        { text: this.$t('ELE0181'), value: 'inspResultCd', divider: true },
        { text: this.$t('ELE0503'), value: 'srcInspResultCd', divider: true },
        { text: this.$t('ELE0137'), value: 'inspIndexNo', divider: true },
        { text: this.$t('ELE0048'), value: 'inspCompanyName', divider: true },
        { text: this.$t('ELE0140'), value: 'inspTimingCd', divider: true },
        { text: this.$t('ELE0358'), value: 'inspStartDatetime', divider: true },
        { text: this.$t('ELE0210'), value: 'inspEndDatetime', divider: true },
        { text: this.$t('ELE0049'), value: 'lotNo', divider: true },
        { text: this.$t('ELE0031'), value: 'partCd', divider: true },
        { text: this.$t('ELE0032'), value: 'partName', divider: true },
        { text: this.$t('ELE0224'), value: 'model', divider: true },
        { text: this.$t('ELE0116'), value: 'inspCat1Name', divider: true },
        { text: this.$t('ELE0117'), value: 'inspCat2Name', divider: true },
        { text: this.$t('ELE0051'), value: 'moldNo', divider: true },
        { text: this.$t('ELE0050'), value: 'lotQty', divider: true, align: 'end' },
        { text: this.$t('ELE0545'), value: 'mmmmApplNo', divider: true },
        { text: this.$t('ELE0505'), value: 'dispositionCd', divider: true },
        { text: this.$t('ELE0053'), value: 'matlSpec', divider: true },
        { text: this.$t('ELE0345'), value: 'relInspIndexNo' },
      ],
      searchCondition: {
        inspCompanyCd: '',
        inspIndexNo: '',
        inspDateFrom: moment().format('YYYY-MM-DD'),
        inspDateTo: moment().format('YYYY-MM-DD'),
        lotNo: '',
        partCd: '',
        model: '',
        inspStatus: [InspStatusCd.WAITING_FOR, InspStatusCd.IN_PROGRESS],
        showAutoCompleted: false,
        inspCat1: [],
        inspCat2: [],
        srcInspNeeded: false,
      },
      mmmmDialog: false,
      selected4MLink: null,
    }
  },

  computed: {
    enumOqcIqcCd: () => OqcIqcCd,
  },

  methods: {
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },
    getColorInspResult(inspResultCd) {
      // 検査結果に対応する色設定
      let color = ''

      if (inspResultCd == InspResultCd.OK) {
        color = '#EDEFFD'
      } else if (inspResultCd == InspResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (inspResultCd == InspResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },
    initInspStatusItems() {
      Object.keys(InspStatusCd).forEach((inspStatus) => {
        const item = {
          inspStatusCd: InspStatusCd[inspStatus],
          inspStatusText: this.$t('InspIndex.InspStatusCd.' + InspStatusCd[inspStatus]),
        }
        this.inspStatusItems.push(item)
      })
    },
    // 検査インデックス編集,コピーのモーダルを開く
    onClickInquiry(inspIndexNo) {
      this.mode = ModalMode.INQUIRY
      this.selectedIndexNo = inspIndexNo
      this.indexDialog = true
    },
    onClickEdit(inspIndexNo) {
      this.mode = ModalMode.EDIT
      this.selectedIndexNo = inspIndexNo
      this.indexDialog = true
    },
    onClickCopy(inspIndexNo) {
      this.mode = ModalMode.COPY
      this.selectedIndexNo = inspIndexNo
      this.indexDialog = true
    },
    onClickLotNo(item) {
      this.$router
        .push({
          name: 'T15',
          query: { inspIndexNo: item.inspIndexNo, acceptDateFrom: this.toLocalDate(item.inspCreateDatetime) },
        })
        .catch(() => {})
    },
    onClickInspSub(item) {
      this.selectedSubItems = {
        inspIndexNo: item.inspIndexNo,
        manufacturerName: item.manufacturerName,
        inspCompanyCd: item.inspCompanyCd,
        inspCompanyName: item.inspCompanyName,
        lotDate: this.toLocalDate(item.lotDate),
        inspStatusCd: item.inspStatusCd,
        lotNo: item.lotNo,
        partCd: item.partCd,
      }
      this.subDialog = true
    },
    onClickMmmmSub(item) {
      this.selectedMmmmItems = {
        inspIndexNo: item.inspIndexNo,
        inspCompanyName: item.inspCompanyName,
        inspCompanyCd: item.inspCompanyCd,
        lotNo: item.lotNo,
        partCd: item.partCd,
      }
      this.mmmmSubDialog = true
    },
    can4MClicked(item) {
      if (item.mmmmApplNo && item.mmmmApplNo != InspectionIndex4M.NOT_STARTED_YET) {
        return true
      }
      return false
    },
    async onClickSearch() {
      this.startLoading()
      try {
        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          inspCompanyCd: this.searchCondition.inspCompanyCd,
          inspIndexNo: this.searchCondition.inspIndexNo,
          inspDateFrom: this.searchCondition.inspDateFrom,
          inspDateTo: this.searchCondition.inspDateTo,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          model: this.searchCondition.model,
          inspStatus: this.searchCondition.inspStatus,
          showAutoCompleted: this.searchCondition.showAutoCompleted,
          inspCat1: this.searchCondition.inspCat1,
          inspCat2: this.searchCondition.inspCat2,
          srcInspNeeded: this.searchCondition.srcInspNeeded,
        }
        this.items = await API.get('/inspIndex/inspIndexes', params)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },
  },

  mounted() {
    this.initInspStatusItems()
    this.onClickSearch()
  },
}
</script>
